module.exports = __webpack_public_path__ + "img/[心碎].e8fc578a.svg";